import { localStorageHelper } from '../../../../../../utils/localStorageHelper'

// Per-user persistence for the trend tool's frequency choice. Same
// shape as chartTypePreference. The default `Automatic` lets Orion
// pick a cadence aiming for ~2000 intervals across the chosen date
// range; the picker also exposes explicit cadences for override.

export const FREQUENCIES = Object.freeze([
  'Automatic',
  'Daily',
  'Weekly',
  'Monthly',
  'Quarterly',
  'Annually'
])
export const DEFAULT_FREQUENCY = 'Automatic'

function storageKey (userId) {
  return `portfolioExplorer.${userId}.utilityPanel.trend.frequency`
}

export function loadFrequency (userId) {
  if (userId == null) return DEFAULT_FREQUENCY
  const stored = localStorageHelper.tryLoad(storageKey(userId))
  return FREQUENCIES.includes(stored) ? stored : DEFAULT_FREQUENCY
}

export function saveFrequency (userId, freq) {
  if (userId == null) return
  if (!FREQUENCIES.includes(freq)) return
  localStorageHelper.tryStore(storageKey(userId), freq)
}
